export const AUTH_CHANGED = 'click-auth-changed';

export function getAuthToken() {
  const token = localStorage.getItem('authToken');
  return token?.trim() && token !== 'undefined' && token !== 'null' ? token : null;
}

export function notifyAuthChanged() {
  window.dispatchEvent(new Event(AUTH_CHANGED));
}

export function subscribeToAuth(callback) {
  window.addEventListener('storage', callback);
  window.addEventListener(AUTH_CHANGED, callback);
  return () => {
    window.removeEventListener('storage', callback);
    window.removeEventListener(AUTH_CHANGED, callback);
  };
}
